import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { AlertTriangle } from 'lucide-react';
export const Hero = () => {
  const [showColon, setShowColon] = useState(true);
  useEffect(() => {
    const interval = setInterval(() => {
      setShowColon(prev => !prev);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden pt-16 pb-12 md:pt-20 md:pb-16" data-id="element-57">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-58">
        <img src="https://cdn.magicpatterns.com/uploads/iDs9MAR2uGXk7HhZFjyVsY/EL_PLAN_DE_RECUPERACION_DE_LAS_24HORAS.png" alt="Trader bajo estrés frente a múltiples pantallas" className="w-full h-full object-cover object-center opacity-40 mix-blend-luminosity" data-id="element-59" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0F]/80 via-[#0A0A0F]/90 to-[#0A0A0F]" data-id="element-60"></div>
        <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-61"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-4xl text-center" data-id="element-62">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="flex flex-col items-center" data-id="element-63">
          {/* Countdown Badge */}
          <div className="inline-flex items-center gap-2 md:gap-3 bg-brand-surface/80 border border-brand-red/30 px-4 md:px-6 py-2 rounded-full mb-6 md:mb-8 backdrop-blur-sm" data-id="element-64">
            <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-brand-red animate-pulse" data-id="element-65" />
            <span className="font-mono text-base md:text-2xl text-brand-red font-bold tracking-widest whitespace-nowrap" data-id="element-66">
              24
              <span className={showColon ? 'opacity-100' : 'opacity-0'} data-id="element-67">:</span>
              00
              <span className={showColon ? 'opacity-100' : 'opacity-0'} data-id="element-68">:</span>
              00 HRS
            </span>
          </div>

          <h1 className="text-[2.25rem] leading-[1.05] sm:text-5xl md:text-7xl lg:text-8xl mb-5 md:mb-6 text-glow-red px-2" data-id="element-69">
            EL PLAN DE RECUPERACIÓN DE LAS 24 HORAS:
            <span className="block text-2xl sm:text-3xl md:text-5xl lg:text-6xl mt-3 md:mt-4 text-white opacity-90" data-id="element-70">
              SISTEMA DE RESCATE PARA TRADERS
            </span>
          </h1>

          <p className="text-base sm:text-lg md:text-2xl text-gray-300 mb-8 md:mb-10 max-w-3xl mx-auto font-medium leading-relaxed px-2" data-id="element-71">
            Detén la hemorragia, recupera tu estabilidad emocional y salva tu
            cuenta de trading en las próximas 48 horas sin caer en el trading de
            venganza.
          </p>

          <Button scrollTarget="oferta" className="w-full sm:w-auto text-base sm:text-lg md:text-xl px-6 sm:px-10 py-4 sm:py-5" data-id="element-72">
            ¡QUIERO EL PLAN DE RESCATE AHORA!
          </Button>
        </motion.div>
      </div>
    </section>;
};